import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/thongtinStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";

const Capnhatvanban = React.memo(function Capnhatvanban(props) {
  const classes = useStyles();
  const { vanbanid } = props;
  const [sokyhieu, setSokyhieu] = React.useState("");
  const [ngayvanban, setNgayvanban] = React.useState("");
  const [trichyeu, setTrichyeu] = React.useState("");
  const [theloai, setTheloai] = React.useState("");
  const [loaivanban, setLoaivanban] = React.useState("");
  const [coquanbanhanh, setCoquanbanhanh] = React.useState("");
  const [nguoiky, setNguoiky] = React.useState("");
  const [fileid, setFileid] = React.useState([]);
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  const getvanbantheoid = () => {
    var url =
      Config.backend + "/api/QLVanBan/getvanbantheoid?vanban_id=" + vanbanid;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSokyhieu(data[0].sokyhieu);
        setTrichyeu(data[0].trichyeu);
        setNgayvanban(data[0].ngaybanhanh);
        setTheloai(data[0].theloaivb);
        setLoaivanban(data[0].loaivb);
        setCoquanbanhanh(data[0].coquanbanhanh);
        if (data[0].nguoiky) setNguoiky(data[0].nguoiky);
        if (data[0].upload_id) {
          data.map((item) => {
            setFileid((oldArray) => [
              ...oldArray,
              { filename: item.name + item.ext, id: item.upload_id },
            ]);
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const downloadfile = (id) => {
    window.location.href = Config.link + id;
  };
  const reviewfile = (id) => {
    window.open("https://docs.google.com/viewer?url=" + Config.link + id);
  };
  React.useEffect(() => {
    getvanbantheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số ký hiệu"
                variant="outlined"
                size="small"
                disabled
                value={sokyhieu}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Ngày ban hành"
                variant="outlined"
                size="small"
                disabled
                value={ngayvanban}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Trích yếu"
                variant="outlined"
                size="small"
                disabled
                value={trichyeu}
                multiline
                rows={2}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Thể loại"
                variant="outlined"
                size="small"
                disabled
                value={theloai}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Loại văn bản"
                variant="outlined"
                size="small"
                disabled
                value={loaivanban}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Cơ quan ban hành"
                variant="outlined"
                size="small"
                disabled
                value={coquanbanhanh}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Người ký"
                variant="outlined"
                size="small"
                value={nguoiky}
                disabled
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <FormControl
              style={{
                width: "100%",
                height: "auto",
                float: "right",
                marginTop: 10,
              }}
            >
              {fileid.map((prop, i) => {
                return (
                  <span key={i} className={classes.a_chitet_file}>
                    <div key={i} style={{ display: "flex" }}>
                      <li>{prop.filename}</li>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() => downloadfile(prop.id)}
                        style={{ height: "20px", marginLeft: "15px" }}
                      >
                        Download
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() => reviewfile(prop.id)}
                        style={{ height: "20px", marginLeft: "15px" }}
                      >
                        Xem file
                      </Button>
                    </div>
                  </span>
                );
              })}
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ margin: 0 }}></CardFooter>
    </div>
  );
});

Capnhatvanban.propTypes = {
  vanbanid: PropTypes.number,
};
export default Capnhatvanban;
